import { render, staticRenderFns } from "./chooser.vue?vue&type=template&id=6732d691&scoped=true"
import script from "./chooser.vue?vue&type=script&lang=ts"
export * from "./chooser.vue?vue&type=script&lang=ts"
import style0 from "./chooser.vue?vue&type=style&index=0&id=6732d691&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6732d691",
  null
  
)

export default component.exports